import { UserModel } from 'models';

const initialState: UserModel.IUser = {
  fullName: '',
  username: '',
  email: '',
  companyUserId: '',
  currentCompanyId: '',
  isFcaUser: false,
  permissions: [],
  isAdmin: false,
  isAdminOnAnyProject: false,
  isSuperAdmin: false,
  isWorker: false,
  isOsr: false,
  isAdminSession: false,
  workerId: '',
  userId: '',
};

export default initialState;
